import { Sentry } from "@autocorp/sentry";
export default Sentry;
